// eslint-disable-next-line no-restricted-syntax
export enum DeploymentEnvironmentName {
  LOCAL = "local",
  DEVELOPMENT = "development",
  STAGING = "staging",
  PROD_SHADOW = "prod-shadow",
  PROD_RECREATED = "prod-recreated",
  PRODUCTION = "production",
}

// eslint-disable-next-line no-restricted-syntax
export enum NodeEnvironment {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
  TEST = "test",
}
